import React, { useMemo } from "react";

export default function ProgressRing({ percent = 0 }) {
  // -------------------------
  // Normalize percent (safety)
  // -------------------------
  const safePercent = Math.min(100, Math.max(0, percent));

  // -------------------------
  // Memoized style (performance)
  // -------------------------
  const style = useMemo(() => {
    return {
      background: `conic-gradient(
        var(--cw-ring-highlight, #fff) ${safePercent}%,
        var(--cw-ring-track, #2f5d69) ${safePercent}% 100%
      )`,
    };
  }, [safePercent]);

  // -------------------------
  // Render
  // -------------------------
  return (
    <div
      className="progress-ring"
      style={style}
      role="progressbar"
      aria-valuenow={safePercent}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
}